













 















const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "promptId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "promptId",
        "variableName": "promptId"
      }
    ],
    "concreteType": "RemoveReflectTemplatePromptPayload",
    "kind": "LinkedField",
    "name": "removeReflectTemplatePrompt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReflectPrompt",
        "kind": "LinkedField",
        "name": "prompt",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveReflectTemplatePromptMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveReflectTemplatePromptMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "m_SjjUIJoimqamONORTIM2VA",
    "metadata": {},
    "name": "RemoveReflectTemplatePromptMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "a6df6e2cafc39bcd8e3e3cb7c4873f56";

export default node;
